import React, {useState} from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import NumericInput from 'ui-library/inputs/NumericInput';
import Modal from 'ui-library/modals/Modal';
import {NumericInputChangeEvent} from 'util/Types';

export interface ReplicateByConstantModalProps {
  initialValue?: number | null;
  onRequestClose: () => void;
  onRequestSubmit: (constantValue: number) => void;
}

export default function ReplicateByConstantModal(props: ReplicateByConstantModalProps): JSX.Element {
  const [constantValue, setConstantValue] = useState(props.initialValue || 0);
  return (
    <Modal
      buttons={[
        {
          style: ButtonStyle.SECONDARY,
          submit: true,
          text: 'Done',
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onRequestSubmit(constantValue);
      }}
      title="Replicate by constant"
    >
      <FieldLabel label="Constant" labelStyle={LabelStyle.LABEL} />
      <NumericInput
        min={0}
        value={constantValue}
        placeholder="Constant value"
        onChange={(e: NumericInputChangeEvent) => {
          if (e.target.numericValue != null) {
            setConstantValue(e.target.numericValue);
          }
        }}
        validateInteger={true}
      />
    </Modal>
  );
}
